import React from 'react'
import Link from 'next/link'
import { useDispatch } from 'react-redux'
import { setFilters } from '@/store/slices/speakersSlice'
import { useRouter } from 'next/router'

const Logo = () => {
  const logo_img =
    'https://images.ctfassets.net/p6iqoqavudao/6kvSEytRHYr26LWsbZDLj9/29dccfa66e5023f637ac263b25092ae6/UTA_Speakers_Logo.svg'
  const dispatch = useDispatch()
  const router = useRouter()

  const handleRedirect = () => {
    if (typeof window !== 'undefined') {
      dispatch(
        setFilters({
          categories: null,
          searchQuery: '',
          types: null,
          profileCategory: null,
          relatedSpeakers: null,
          sortOrder: null,
        })
      )
      router.push('/')
    }
  }

  return (
    <div onClick={() => handleRedirect()}>
      <Link href="/" as={'/'} legacyBehavior>
        <a>
          <img
            src="/UTA_Speakers_Logo.svg"
            className="cursor-pointer logo md:mb-1"
            alt="link graphic united talent agency"
          />
        </a>
      </Link>
    </div>
  )
}

export default Logo
